import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { enlistDealers, sendOTP, verifyOtp } from '../../../store/login/action';
import { setupToast } from '../../../store/toast/action';
import { getUserConsent, setUser } from '../../../store/user/action';
import MobileLogin from './component';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    sendOtpConnect: sendOTP,
    verifyOtpConnect: verifyOtp,
    setupToastConnect: setupToast,
    enlistDealersConnect: enlistDealers,
    setUserConnect: setUser,
    getUserConsentConnect: getUserConsent
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MobileLogin);